import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

export default function Navbar() {
    const navigate = useNavigate();
    const { logout } = useApp();

    return (
        <AppBar position="static">
            <Toolbar>
                <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, cursor: 'pointer' }} onClick={() => navigate('/')}>
                    <Box
                        component="img"
                        src="/logo.png"
                        alt="AutoGrow BR"
                        sx={{ width: 32, height: 32, mr: 1 }}
                    />
                    <Typography variant="h6">AutoGrow BR</Typography>
                </Box>
                <Button color="inherit" onClick={() => navigate('/dashboard')}>Dashboard</Button>
                <Button color="inherit" onClick={() => navigate('/plants')}>Plantas</Button>
                <Button color="inherit" onClick={() => navigate('/history')}>Histórico</Button>
                <Button color="inherit" onClick={() => navigate('/guia', { state: { from: 'dashboard' } })}>Guia</Button>
                <Button color="inherit" onClick={() => navigate('/comprar')}>Comprar</Button>
                <Button color="inherit" onClick={() => navigate('/account')}>Conta</Button>
                <Button color="inherit" onClick={() => navigate('/settings')}>Configurações</Button>
                <Button color="inherit" onClick={() => { logout(); navigate('/'); }}>Sair</Button>
            </Toolbar>
        </AppBar>
    );
}
